import { apiSlice } from './apiSlice.js';
import { WHATSAPP_URL } from '../constants.js';

export const whatsAppApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sendWhatsAppMessage: builder.mutation({
      query: ({phone, message}) => ({
        url: WHATSAPP_URL,
        method: 'POST',
        body: {phone, message},
      }),
      invalidatesTags: ['WhatsAppMessage']
    }),
    getWhatsAppMessages: builder.query({
      query: () => ({
        url: WHATSAPP_URL
      }),
      keepUnunsedDataFor: 5
    }),
    sendWhatsAppReply: builder.mutation({
      query: ({ to, message }) => ({
        url: `${WHATSAPP_URL}/reply`,
        method: 'POST',
        body: { to, message }
      }),
      invalidatesTags: ['WhatsAppMessage']
    }),
    sendWhatsAppOTP: builder.mutation({
      query: ({orderId}) => ({
        url: `${WHATSAPP_URL}/sendotp`,
        method: 'POST',
        body: {orderId},
      }),
      invalidatesTags: ['WhatsAppMessage']
    }),
    sendWhatsAppIntroWebsite: builder.mutation({
      query: ({phoneNumbers}) => ({
        url: `${WHATSAPP_URL}/sendintrowebsite`,
        method: 'POST',
        body: {phoneNumbers},
      }),
      invalidatesTags: ['WhatsAppMessage']
    }),
    sendWhatsAppIntro: builder.mutation({
      query: ({phoneNumbers}) => ({
        url: `${WHATSAPP_URL}/sendintro`,
        method: 'POST',
        body: {phoneNumbers},
      }),
      invalidatesTags: ['WhatsAppMessage']
    }),
    sendSourceOrderWhatsApp: builder.mutation({
      query: ({ orderId }) => ({
        url: `${WHATSAPP_URL}/sourceorder`,
        method: "POST",
        body: { orderId },
      }),
      invalidatesTags: ["WhatsAppMessage"],
    })
  })
});

export const {
  useSendWhatsAppMessageMutation,
  useGetWhatsAppMessagesQuery,
  useSendWhatsAppReplyMutation,
  useSendWhatsAppOTPMutation,
  useSendWhatsAppIntroWebsiteMutation,
  useSendWhatsAppIntroMutation,
  useSendSourceOrderWhatsAppMutation
 } = whatsAppApiSlice;